import * as lodash from 'lodash';
import * as moment from 'moment';

/**
 * Custom Utilities
 * NOTE: Please make sure to not have any name conflicts with library
 *       If any name conflict prefix the name with <__>
 *       You can view the list of the library (lodash) <https://lodash.com/docs/4.17.15>
 * @object
 */
const utilities = {

  /** Returns the console.log function */
  log: () => console.log,

  /** Example conflict Utility function */
  __conflictUtil: () => console.log('[Utilities] This is an example of conflict number'),

  keyToTitle: (string) =>
    string.replace(/([A-Z])/g, match => ` ${match}`)
      .replace(/^./, match => match.toUpperCase())
      .trim(),

  getMonthName: (date: Date) => {
    const MONTH_NAMES = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"];
    return MONTH_NAMES[date.getMonth()];
  },

  getDateTimeDifference: (date: string) => moment(date).fromNow(),

  isGreaterThanNow: (input) => new Date(input).getTime() > new Date().getTime(),

  // Abbreviate number, because in some places we can't use Angular shortNumber
  abbreviateNumber(count = 0, decimals = 2) {
    const COUNT_ABBRS = ["", "K", "M", "B", "T"];
    let isNegative = false;
    if (count < 0) {
      isNegative = true;
      count = Math.abs(count);
    }
    const i =
      0 === count ? count : Math.floor(Math.log(count) / Math.log(1000));

    let result = parseFloat((count / Math.pow(1000, i)).toFixed(decimals));
    if(isNegative) {
      result = result * -1;
    }
    return `${result}${COUNT_ABBRS[i]}`;
  },
};

/** merge & export  custom + library utilites*/
export const _ = {...utilities, ...lodash};
